const checkBeforeSave = (tableName, payload, ogTableDef) => {
  let tempFlag = false;
  let tFields = ogTableDef[tableName];
  //console.log("checking enablement: " + JSON.stringify(tFields));
  for (let tFkey in tFields) {
    // console.log(
    //   "tFkey: " + tFkey + " isMust flag is: " + tFields[tFkey].isMust
    // );
    if (
      tFields[tFkey].isMust &&
      tFields[tFkey].isMust === "true" &&
      (!payload[tFkey] || payload[tFkey] === "")
    ) {
      tempFlag = true;
    }
  }

  //console.log("returning: " + tempFlag);

  return tempFlag;
};

export default checkBeforeSave;



// WEBPACK FOOTER //
// ./src/app/components/checkBeforeSave/checkBeforeSave.js